import { CardSvg } from '@/play/cardSvg'

/** Home card art for Letter blocks: wooden ABC blocks on the floor, one lifted with its shadow under it. No text: the letters are strokes. */
export function LetterBlocksCardArt() {
  return (
    <CardSvg bg="#f3f6f8">
      <path d="M10 186 L 60 120 H 300 L 312 186 Z" fill="#dfe6ea" />
      <path d="M210 120 H 296 L 300 146 H 200 Z" fill="#b9c7d2" />
      <Block x={60} y={140} ink="#e63946" letter="M15 30 V 8 L 24 20 L 33 8 V 30" />
      <Block x={120} y={148} ink="#2f7dd1" letter="M15 30 L 24 8 L 33 30 M 18 22 H 30" />
      <Block x={218} y={104} ink="#1aa5a0" letter="M30 8 H 17 V 30 H 30 M 17 19 H 28" />
      <ellipse cx="190" cy="172" rx="26" ry="6" fill="#1d2b36" opacity="0.18" />
      <Block x={166} y={96} ink="#2a9d4b" letter="M24 8 C 14 8, 14 30, 24 30 C 34 30, 34 8, 24 8 Z" />
    </CardSvg>
  )
}

/** One block in a simple oblique view: top with the raised letter, front face. */
function Block({ x, y, ink, letter }: { x: number; y: number; ink: string; letter: string }) {
  return (
    <g transform={`translate(${x} ${y})`}>
      <path d="M0 10 L 10 0 H 48 L 38 10 Z" fill="#f1d3a6" stroke="#d2a86e" strokeWidth="1.5" />
      <rect x="0" y="10" width="38" height="26" fill="#e8c48e" stroke="#d2a86e" strokeWidth="1.5" />
      <path d="M38 10 L 48 0 V 26 L 38 36 Z" fill="#d2a86e" />
      <g transform="translate(-4 13) scale(0.9 0.75)">
        <path d={letter} fill="none" stroke={ink} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </g>
  )
}
